import Media from 'react-media';
import { withTheme } from 'emotion-theming';

const ShowOnSmallScreen = ({ children, theme }) => (
  <Media query={`(min-width: ${theme.breakpoints[0]})`}>{(matches) => (matches ? null : children)}</Media>
);

export default withTheme(ShowOnSmallScreen);
